<template>
  <div class="photo-upload">
    <Upload
      v-if="!model"
      :accept="UPLOAD_ACCEPT_TYPE.IMAGE"
      :listType="'picture-card'"
      :disabled="disabled"
      name="photo_file"
      :file="file"
      :id="field.name"
      :limit="field.limit || 1"
    ></Upload>
    <div class="photo-block" v-if="model && hasActions">
      <Picture :url="uploadLink" alt="" width="144" height="144" />
      <Button
        buttonColor="transparent"
        iconName="delete-trash"
        hasLeftIcon
        iconColor="#CDD4DA"
        :disabled="disabled"
        class="delete-photo"
        @click="removeCandidatePhoto"
      />
    </div>
  </div>
</template>

<script>
import { FIELD, UPLOAD_ACCEPT_TYPE } from '@/utils/constants';
import { store } from '@/store';
import { postController } from '@/controllers/request.js';
import { mixin } from '@/utils/mixins';
import Upload from './Upload';
import Button from 'Elements/Button/Button';
import Picture from 'Elements/Picture/Picture';
import './photo.scss';

export default {
  mixins: [mixin],
  props: {
    model: String,
    field: Object,
    file: Array,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      FIELD,
      UPLOAD_ACCEPT_TYPE
    };
  },
  computed: {
    hasActions() {
      const actions = this.field?.actions;
      return Array.isArray(actions)
        ? actions.length
        : actions && Object.keys(actions).length
        ? Object.keys(actions).length
        : false;
    },
    uploadLink() {
      return this.field?.actions?.link;
    },
    requestSent: {
      get() {
        return store.state.common.requestSent;
      },
      set(val) {
        store.commit('common/setRequestState', val);
      }
    }
  },
  methods: {
    removeCandidatePhoto() {
      if (!this.requestSent && this.field.actions?.delete) {
        this.requestSent = true;
        postController({ url: this.field.actions?.delete })
          .then(() => location.reload())
          .catch(err =>
            this.catchError(
              err,
              'Возникла ошибка при удалении фото кандидата',
              'photo remove'
            )
          )
          .finally(() => (this.requestSent = false));
      }
    }
  },
  components: { Upload, Button, Picture }
};
</script>

<style lang="scss" scoped>
.photo-upload {
  .el-upload--picture-card {
    width: auto;
    border: none;
  }

  .photo-block {
    width: 144px;
    height: 144px;

    &.el-button {
      .medium {
        height: 144px;
        align-content: center;
        margin-top: 14px;
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .upload-area {
    & ::v-deep .el-upload {
      & > .el-upload-dragger {
        border: 1px solid #e9edf2 !important;
        border-radius: 4px; //12
        display: flex;
        width: 144px !important;
        height: 144px !important;
      }
    }
  }
}
</style>

<style lang="scss">
.photo-upload {
  .el-upload--picture-card {
    width: auto;
    border: none;
  }

  .upload-area {
    .uploaded {
      .el-upload-list__item {
        width: 144px;
        height: 144px;
        align-self: center;
      }
    }
  }
}
</style>
